module.exports = __webpack_public_path__ + "prod/1.42.2/img/api_interface.bb96de66.png";